/**
 * Gift With Purchase slider.
 *
 * Only ever does anything when a [data-gwp-slider] element is present, which
 * the theme renders solely when two or more gift slots are live. A single gift
 * renders a static box with no slider markup, so this is a no-op there.
 */
function initGwpSlider(root) {
  // The theme editor fires shopify:section:load repeatedly; without this guard
  // every reload would bind another set of click and scroll handlers.
  if (root.dataset.gwpInit === 'true') return;

  var track = root.querySelector('[data-gwp-track]');
  var dots = Array.prototype.slice.call(root.querySelectorAll('[data-gwp-dot]'));
  var slides = Array.prototype.slice.call(root.querySelectorAll('[data-gwp-slide]'));

  if (!track || slides.length < 2 || dots.length !== slides.length) return;

  root.dataset.gwpInit = 'true';

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setCurrent(index) {
    for (var i = 0; i < dots.length; i++) {
      if (i === index) {
        dots[i].setAttribute('aria-current', 'true');
      } else {
        dots[i].removeAttribute('aria-current');
      }
    }
  }

  dots.forEach(function (dot, index) {
    dot.addEventListener('click', function () {
      // Measured inside the track's padding box - see reviews-carousel-manual.js.
      // Equivalent today (the track has no padding) but correct if that changes.
      var left = slides[index].offsetLeft - track.offsetLeft;
      if (track.scrollTo) {
        track.scrollTo({ left: left, behavior: reduceMotion ? 'auto' : 'smooth' });
      } else {
        track.scrollLeft = left;
      }
      setCurrent(index);
    });
  });

  var ticking = false;
  track.addEventListener(
    'scroll',
    function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        var origin = track.offsetLeft;
        var nearest = 0;
        var best = Infinity;
        for (var i = 0; i < slides.length; i++) {
          var delta = Math.abs(slides[i].offsetLeft - origin - track.scrollLeft);
          if (delta < best) {
            best = delta;
            nearest = i;
          }
        }
        setCurrent(nearest);
      });
    },
    { passive: true }
  );
}

function initAllGwpSliders() {
  var roots = document.querySelectorAll('[data-gwp-slider]');
  for (var i = 0; i < roots.length; i++) initGwpSlider(roots[i]);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllGwpSliders);
} else {
  initAllGwpSliders();
}

// Re-init when the theme editor swaps a section.
document.addEventListener('shopify:section:load', initAllGwpSliders);
